/**
 * Copyright IBM Corp. 2022, 2026
 */

import classNames from 'classnames'
import HeadingText from 'components/materia/sub-blocks/heading-text'
import { getAlignment } from 'components/materia/sub-blocks/heading-text/utils'
import ProductLogoSet from 'components/materia/product-logo-set'
import Eyebrow from 'components/materia/sub-blocks/eyebrow'
import type { SectionHeadlineFieldsFragment } from 'types/dato'
import { Layout } from 'components/materia/layout'
import { vercelSplit } from '@web/cms'
import s from './style.module.css'

const SectionHeadline = ({
	layout,
	alignment = 'center',
	modularEyebrow,
	heading,
	headingElement = 'h2',
	headingColor,
	size = 'medium',
	description,
	ctas,
	productLogoSet,
	locale,
}: SectionHeadlineFieldsFragment & { locale?: string }) => (
	<Layout layout={layout}>
		<div className={classNames(s.root, s[vercelSplit(alignment)])}>
			{modularEyebrow && (
				<Eyebrow eyebrow={modularEyebrow} className={s.modularEyebrow} />
			)}
			<HeadingText
				heading={heading}
				headingElement={headingElement}
				description={description}
				size={size}
				alignment={getAlignment(vercelSplit(alignment))}
				className={s.heading}
				ctas={ctas}
				headingColor={headingColor}
				locale={locale}
			/>
			{productLogoSet ? (
				<div className={s.productLogoSet}>
					<ProductLogoSet {...productLogoSet} />
				</div>
			) : null}
		</div>
	</Layout>
)

export default SectionHeadline
